// removed by extract-text-webpack-plugin
module.exports = {"wrap":"pages-MyAccount-wrap","siderBar":"pages-MyAccount-siderBar","linkList":"pages-MyAccount-linkList","active":"pages-MyAccount-active","content":"pages-MyAccount-content","siderBarIcon":"pages-MyAccount-siderBarIcon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/MyAccount/index.css
// module id = 449
// module chunks = 0